import React from "react";

function Shoot() {

    return (
    
        <g id="shoot">
            <iframe
                className="shoot"
                src="https://giphy.com/embed/1xo9COytfPE9chS05b" 
                width="844" 
                height="475" 
                frameBorder="0" 
                loop="0"
                autoplay="0"
            >
            </iframe>
        </g>

    )

}

export default Shoot 